import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-muted text-muted-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground',
        outline: 'border-line text-fg-2',
        success: 'border-transparent bg-success text-success-foreground',
        warning: 'border-transparent bg-warning text-warning-foreground',
        info: 'border-transparent bg-info text-white',
        // Roles carry the accent, because "who is an Admin" is the thing to
        // notice in a user list; the read-only role stays quiet.
        admin: 'border-accent-line bg-accent-soft text-accent',
        safetynet: 'border-line bg-muted text-muted-foreground',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);
